/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
export type paths = {
    readonly '/api/v2/mqtt/topics/levels': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /**
         * Get immediate children of a prefix
         * @description Returns the child nodes for a given prefix.
         */
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Path prefix (URL-encoded). Needs to be built by joining previous levels with '/'. If omitted, root level is assumed. */
                    readonly prefix?: string
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description List of child nodes wrapped in JSON:API envelope. */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': components['schemas']['JSONAPIEnvelope'] & {
                            readonly data: components['schemas']['LevelsData']
                        }
                    }
                }
                /** @description Internal error retrieving levels. */
                readonly 500: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': components['schemas']['ErrorEnvelope']
                    }
                }
                readonly 503: components['responses']['ServiceUnavailable']
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/mqtt/topics/search': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /**
         * Search topics by prefix
         * @description Returns all topics matching a given prefix.
         */
        readonly get: {
            readonly parameters: {
                readonly query: {
                    /** @description Path prefix to search for (URL-encoded). */
                    readonly prefix: string
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description Search results wrapped in JSON:API envelope. */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': components['schemas']['JSONAPIEnvelope'] & {
                            readonly data?: components['schemas']['SearchResult']
                        }
                    }
                }
                /** @description Missing prefix parameter. */
                readonly 400: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': components['schemas']['ErrorEnvelope']
                    }
                }
                /** @description Internal error during search. */
                readonly 500: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': components['schemas']['ErrorEnvelope']
                    }
                }
                readonly 503: components['responses']['ServiceUnavailable']
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly ChildNode: {
            readonly has_more: boolean
            readonly name: string
        }
        readonly ErrorEnvelope: components['schemas']['JSONAPIEnvelope'] & {
            readonly errors?: readonly components['schemas']['JSONAPIError'][]
        }
        readonly JSONAPIEnvelope: {
            readonly jsonapi: {
                /** @example 1.1 */
                readonly version?: string
            }
            /** @example {} */
            readonly meta: {
                readonly [key: string]: unknown
            }
        }
        readonly JSONAPIError: {
            /** @example The server encountered an unexpected condition that prevented it from fulfilling the request. */
            readonly detail: string
            /** @example 500 */
            readonly status: string
            /** @example Internal Server Error */
            readonly title: string
        }
        readonly LevelsData: {
            readonly children: readonly components['schemas']['ChildNode'][]
        }
        readonly SearchResult: readonly string[]
    }
    responses: {
        /** @description Service Unavailable (Infrastructure error) */
        readonly ServiceUnavailable: {
            headers: {
                readonly [name: string]: unknown
            }
            content: {
                readonly 'text/plain': string
            }
        }
    }
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

/** An auto-generated constant containing all paths */
export const pathsValue = ['/api/v2/mqtt/topics/levels' as const, '/api/v2/mqtt/topics/search' as const]
